__webpack_require__.p = "/energy/water/paper/nature_2025_website/";